import React, { useEffect, useMemo, useState } from "react";
import { PrimaryButton } from "../../components/Buttons.jsx";
import {
  getStripeBannerToken,
  getStripeDocumentToken,
  getStripePayoutToken,
  startStripeOnboarding,
} from "../../api/index.js";
import {
  ConnectAccountOnboarding,
  ConnectComponentsProvider,
  ConnectDocuments,
  ConnectPayouts,
  ConnectNotificationBanner, ConnectAccountManagement,
} from "@stripe/react-connect-js";

import { loadConnectAndInitialize } from "@stripe/connect-js";
import ModalBasic from "../../components/ModalBasic.jsx";
import { useSelector } from "react-redux";
import Loader from "../../components/Loader.jsx";
import config from '@/config';
function PayoutsPanel() {
  const [onboardingToken, setOnboardingToken] = useState(null);
  const [payoutToken, setPayoutToken] = useState(null);
  const [documentToken, setDocumentToken] = useState(null);
  const [bannerToken, setBannerToken] = useState(null);
  const [settingsToken, setSettingsToken] = useState(null);
  const [loadingOnboarding, setLoadingOnboarding] = useState(false);
  const [loadingDocument, setLoadingDocument] = useState(false);
  const { selectedMerchant, selectedLocation } = useSelector(
    (state) => state.app
  );
  const documentStripeConnectInstance = useMemo(() => {
    if (!documentToken) {
      return null;
    }
    return loadConnectAndInitialize({
      publishableKey: config.stripe.pk,
      clientSecret: documentToken,
    });
  }, [documentToken]);
  const payoutStripeConnectInstance = useMemo(() => {
    if (!payoutToken) {
      return null;
    }
    return loadConnectAndInitialize({
      publishableKey: config.stripe.pk,
      clientSecret: payoutToken,
    });
  }, [payoutToken]);
  const onboardingStripeConnectInstance = useMemo(() => {
    if (!onboardingToken) {
      return null;
    }
    return loadConnectAndInitialize({
      publishableKey: config.stripe.pk,
      clientSecret: onboardingToken,
    });
  }, [onboardingToken]);
  const bannerStripeConnectInstance = useMemo(() => {
    if (!bannerToken) {
      return null;
    }
    return loadConnectAndInitialize({
      publishableKey: config.stripe.pk,
      clientSecret: bannerToken,
    });
  }, [bannerToken]);
  const settingsStripeConnectInstance = useMemo(() => {
    if (!settingsToken) {
      return null;
    }
    return loadConnectAndInitialize({
      publishableKey: config.stripe.pk,
      clientSecret: settingsToken,
    });
  }, [settingsToken]);

  useEffect(() => {
    if (selectedMerchant && selectedLocation) {
      getStripeBannerToken().then((res) => {
        setBannerToken(res.client_secret);
      });
      getStripePayoutToken().then((res) => {
        setSettingsToken(res.client_secret);
      });
      getStripePayoutToken().then((res) => {
        setPayoutToken(res.client_secret);
      });
    }
  }, [selectedMerchant, selectedLocation]);

  return (
    <div className="grow">
      {/* Panel body */}
      <div className="p-6 space-y-6">
        <div>
          <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-4">
            Payouts
          </h2>
          <div className="text-sm">
            Banking and payments are managed through Stripe, setup your account
            below to access proceedings to your sales.
          </div>
        </div>

        {payoutToken ? (
          <>
            <section>
              <h3 className="text-xl leading-snug text-slate-800 dark:text-slate-100 font-bold mb-1 ">
                Stripe Account
              </h3>
              <div className="flex flex-col w-fit gap-3">
                {bannerStripeConnectInstance && (
                  <ConnectComponentsProvider
                    connectInstance={bannerStripeConnectInstance}
                  >
                    <ConnectNotificationBanner />
                  </ConnectComponentsProvider>
                )}
                <PrimaryButton
                  onClick={async () => {
                    setLoadingOnboarding(true);
                    const onboardRes = await startStripeOnboarding();
                    setOnboardingToken(onboardRes.client_secret);
                  }}
                  loading={loadingOnboarding}
                >
                  Configure Stripe Account
                </PrimaryButton>

                <PrimaryButton
                  onClick={async () => {
                    setLoadingDocument(true);
                    const onboardRes = await getStripeDocumentToken();
                    setDocumentToken(onboardRes.client_secret);
                  }}
                  loading={loadingDocument}
                >
                  Download documents
                </PrimaryButton>
              </div>
            </section>

            <section>
              {payoutStripeConnectInstance && (
                <ConnectComponentsProvider
                  connectInstance={payoutStripeConnectInstance}
                >
                  <ConnectPayouts />
                </ConnectComponentsProvider>
              )}
            </section>
          </>
        ) : (
          <Loader />
        )}
        {/* Payouts Information */}
      </div>

      {payoutToken && (
        <>
          <ModalBasic
            modalOpen={Boolean(documentStripeConnectInstance)}
            setModalOpen={() => {
              setDocumentToken(null);
              setLoadingDocument(false);
            }}
            width={"xl"}
          >
            <div className="h-[600px] overflow-x-hidden">
              {documentStripeConnectInstance && (
                <ConnectComponentsProvider
                  connectInstance={documentStripeConnectInstance}
                >
                  <ConnectDocuments />
                </ConnectComponentsProvider>
              )}
            </div>
          </ModalBasic>
          <ModalBasic
            modalOpen={Boolean(onboardingStripeConnectInstance)}
            setModalOpen={() => {
              setOnboardingToken(null);
              setLoadingOnboarding(false);
            }}
            width={"xl"}
            title="Connect Account"
          >
            <div className="h-[600px] overflow-x-hidden">
              {onboardingStripeConnectInstance && (
                <ConnectComponentsProvider
                  connectInstance={onboardingStripeConnectInstance}
                >
                  <ConnectAccountOnboarding
                    onExit={() => {
                      setOnboardingToken(null);
                      setLoadingOnboarding(false);
                    }}
                    // Optional: make sure to follow our policy instructions above
                    // fullTermsOfServiceUrl="{{URL}}"
                    // recipientTermsOfServiceUrl="{{URL}}"
                    // privacyPolicyUrl="{{URL}}"
                    // skipTermsOfServiceCollection={false}
                    collectionOptions={{
                      fields: "eventually_due",
                      futureRequirements: "include",
                    }}
                  />
                </ConnectComponentsProvider>
              )}
            </div>
          </ModalBasic>
        </>
      )}
    </div>
  );
}

export default PayoutsPanel;
